/* eslint-disable complexity */
import { Component, Input } from '@angular/core';
import {
  BaseProperties,
  CSSProperties,
  DynamicBannerConfiguration,
  DynamicBannerContent,
  DynamicBannerStyleProperties
} from '../../../models';
import {
  BannerHeader,
  BannerRow
} from '../banner-alert/models/banner-alert.interface';

/**
 * This component is responsible to display icon banner
 * (image with heading, description and more info)
 */
@Component({
  selector: 'idp-banner-icon',
  templateUrl: './banner-icon.component.html',
  styleUrls: ['./banner-icon.component.scss']
})
export class BannerIconComponent
  implements
    BaseProperties<
      DynamicBannerConfiguration,
      DynamicBannerContent,
      DynamicBannerStyleProperties
    >
{
  /** This props holds all content regarding icon image banner */
  @Input() content: DynamicBannerContent = {} as DynamicBannerContent;
  /**
   * This is the primary configuration for icon image banner.
   * You can pass several configuration like device configuration and template configuration
   */
  @Input() config: DynamicBannerConfiguration =
    {} as DynamicBannerConfiguration;

  /** This holds style properties. You can set apply styling according to the use case */
  @Input() styles: DynamicBannerStyleProperties =
    {} as DynamicBannerStyleProperties;

  constructor() {
    /** Set default properties for config, content and styles */
    this.content = {
      imageContent: {
        desktop: { src: '', alt: '' },
        mobile: { src: '', alt: '' }
      }
    };
    this.config = {
      deviceConfig: {
        desktopEnabled: true,
        mobileEnabled: true,
        responsive: true
      },
      templateType: 'iconbanner'
    };
    this.styles = {
      banner: { backgroundColor: '', borderColor: '' },
      heading: { color: '', position: 'left' },
      description: {
        color: '',
        fontSize: '',
        position: 'left'
      },
      textPosition: {
        position: 'left'
      }
    };
  }

  /** Prepare dynamic class for which the banner can be shift to left or right based on the position */
  get bannerRowClass(): BannerRow {
    let flexRow = false;
    let bannerBorder = false;
    if (
      this.styles.textPosition &&
      this.styles.textPosition.position === 'left'
    ) {
      flexRow = true;
    }

    if (this.styles.banner && this.styles.banner.borderColor) {
      bannerBorder = true;
    }
    return { flexRowReverse: flexRow, hasBorder: bannerBorder };
  }

  /** Check desktop image setting is enabled of not */
  get desktopBannerEnabled(): boolean {
    let desktopImageEnabled = false;
    if (
      this.config.deviceConfig.desktopEnabled &&
      this.content.imageContent?.desktop?.src
    ) {
      desktopImageEnabled = true;
    }
    return desktopImageEnabled;
  }

  /**  check mobile image setting is enabled of not */
  get mobileBannerEnabled(): boolean {
    let mobileImageEnabled = false;
    if (
      this.config.deviceConfig.mobileEnabled &&
      this.content.imageContent?.mobile?.src
    ) {
      mobileImageEnabled = true;
    }
    return mobileImageEnabled;
  }

  /**  prepare header styling according to the inputs */
  get headerStyles(): CSSProperties {
    return {
      color: this.styles.heading?.color || '',
      position: this.styles.heading?.position || 'left'
    };
  }

  /**  prepare header content for full image banner */
  get headerContent(): BannerHeader {
    return {
      text: this.content.headerText || '',
      level: this.content.level || ''
    };
  }
}
